import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { sortList } from "../Utils/Sorting";
import * as SGUri from "../Utils/PagesSwitch.js";
import { PRINTER_GET_LIST, PRINTER_ADD_MODIFY, PRINTER_GET_MODEL_LIST, PRINTER_GET_BRAND_LIST } from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";

export function getListaStampanti(filter) {
  var obj = {
    ID          : filter.ID          ,
    Nome        : filter.Nome        ,
    Porta       : filter.Porta       ,
    IDTipologia : filter.IDTipologia ,
    IDImpianto  : filter.IDImpianto  ,
    Ip          : filter.Ip          ,
    Cancellata  : filter.Cancellata  ,
  };

  return {
    [CALL_API]: {
      endpoint: PRINTER_GET_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_STAMPANTE_LIST_REQUEST,
        actionType.SERVICE_STAMPANTE_LIST_SUCCESS,
        actionType.SERVICE_STAMPANTE_LIST_ERROR
      ]
    }
  };
}

export function setStampante(stampante) {
  var obj = {
    ID         : stampante.ID        ,
    Nome       : stampante.Nome      ,
    Ip         : stampante.Ip        ,
    Porta      : stampante.Porta     ,
    Impianto   : stampante.Impianto  ,
    Modello    : stampante.Modello   ,
    IDHolding  : stampante.IDHolding ,
    Cancellata : stampante.Cancellata,
    IDMaster   : stampante.IDMaster  
  };
  return {
    [CALL_API]: {
      endpoint      : PRINTER_ADD_MODIFY,
      authenticated : true,
      method        : "POST",
      types         : [
        actionType.SERVICE_STAMPANTE_SET_REQUEST,
        actionType.SERVICE_STAMPANTE_SET_SUCCESS,
        actionType.SERVICE_STAMPANTE_SET_ERROR
      ],
      data : SGUri.serializeParametersPOST(obj)
    }
  };
}

export const orderListaStampanti = (holdList, value) => {
  return dispatch => {
     dispatch(requestList(actionType.SERVICE_STAMPANTE_LIST_REQUEST));
     dispatch(refreshList(sortList(holdList, value), actionType.SERVICE_STAMPANTE_REFRESH_LIST));
  }
}


export function getListaModelliStampanti(filter) {
  var obj = {
    ID               : filter.ID               ,
    Modello          : filter.Modello          ,
    IDMarca          : filter.IDMarca          ,
    PortaPredefinita : filter.PortaPredefinita ,
  }
  return {
    [CALL_API]: {
      endpoint: PRINTER_GET_MODEL_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_STAMPANTE_MODELLO_LIST_REQUEST,
        actionType.SERVICE_STAMPANTE_MODELLO_LIST_SUCCESS,
        actionType.SERVICE_STAMPANTE_MODELLO_LIST_ERROR
      ]
    }
  };
}

export function getListaMarcheStampanti(filter) {
  var obj = {
    ID : filter.ID,
    Marca : filter.Marca
  };

  return {
    [CALL_API]: {
      endpoint: PRINTER_GET_BRAND_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_STAMPANTE_MARCA_LIST_REQUEST,
        actionType.SERVICE_STAMPANTE_MARCA_LIST_SUCCESS,
        actionType.SERVICE_STAMPANTE_MARCA_LIST_ERROR
      ]
    }
  };
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Stampanti.js